import React from 'react';


import { Input, Space } from 'antd';

import { getAsNumber } from '../../../../../../../utilities/numberConvertion';
import { getRandomId } from '../../../../../../../utilities/randomId';
import AttachmentModal from '../../../../../../../components/Modal/AttachmentModal';
import AttachmentViewModal from '../../../../../../../components/Modal/AttachmentViewModal';



export const TableCol = (handleSave, status) => {

  return [
    {
      key: getRandomId(),
      dataIndex: 'apa',
      title: 'APA Area',
      render: (value) =>
        value?.area ? (
          <div>
            <div style={{ fontWeight: 500 }}>{value.area}</div>
            {value?.scoringMethod && (
              <div style={{ color: '#888', marginTop: 4 }}>
                {`(${value.scoringMethod})`}
              </div>
            )}
          </div>
        ) : null,
    },
    {
      key: 'modal',
      dataIndex: 'modal',
      title: 'Attachments(Need head approval document)',
      render: (value, row) => {
        const title = `Spring`;

        return row && row.apa && row.apa.id !== 'apa_point' ? (
          <Space >
            <Input
              placeholder="Enter"
              value={row?.count}
              disabled={status === 1 || status === 2 || status === 3}
              onChange={(e) => {
                const updatedCount = getAsNumber(e.target.value);

                handleSave({
                  ...row,
                  count: updatedCount,
                  modal: row.modal,

                })
              }
              }
            />


            <AttachmentModal
              row={row}
              action={handleSave}
              parentKey={'modal'}
              title={title}
              disabled={status === 1 || status === 2 || status === 3}
              status={status}
            />

            <AttachmentViewModal // New View Attachment Modal
              row={row}
              parentKey="modal"
              title={title}
            // status={status}
            />
          </Space>
        ) : (
          <>{value}</>
        );
      }

    }
  ]
}
